export function padStart(value: number | string, targetLength = 2, padString = '0'): string {
  if (Number.isFinite(value as number) || typeof value === 'string') {
    return value.toString().padStart(targetLength, padString);
  }

  return '';
}
